"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.coalesce = void 0;
function coalesce(getter, fallback) {
  try {
    var value = getter();
    if (value === null || value === undefined || Number.isNaN(value)) {
      return fallback;
    }
    return value;
  } catch (e) {
    return fallback;
  }
}
exports.coalesce = coalesce;